import { useContext, useRef } from "react";
import { useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContex";
import axios from "axios";

export default function Partilhar() {
  const desc = useRef();
  const [file, setFile] = useState(null);
  const [imgselected, setimgselected] = useState([]);

  const PF = process.env.REACT_APP_PUBLIC_FOLDER;

  const { user } = useContext(AuthContext);

  const submitHandler = async (e) => {
    e.preventDefault();
    const newPost = {
      userId: user._id,
      desc: desc.current.value,
    };

    if (file) {
      const data = new FormData();
      const fileName = Date.now() + file.name;
      data.append("file", file);
      data.append("name", fileName);

      try {
        const res = await axios.post("upload", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        newPost.img = res.data.img;
      } catch (err) {
        console.log(err);
      }
    }

    try {
      await axios.post("post", newPost);
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const changeimg = () => {
      if (file) {
        setimgselected(URL.createObjectURL(file));
      }
    };
    changeimg();
  }, [file]);

  return (
    <>
      <div className="card">
        <div className="card-body p-0">
          <ul className="nav nav-tabs nav-bordered">
            <li className="nav-item">
              <a
                data-bs-toggle="tab"
                aria-expanded="false"
                className="nav-link active px-3 py-2"
              >
                <i className="mdi mdi-pencil-box-multiple font-18 d-md-none d-block"></i>
                <span className="d-none d-md-block">Criar Publicação</span>
              </a>
            </li>
          </ul>
          <div className="tab-content">
            <div className="tab-pane show active p-3">
              <div className="border rounded">
                <form
                  action="#"
                  className="comment-area-box"
                  onSubmit={submitHandler}
                >
                  <textarea
                    ref={desc}
                    rows="4"
                    className="form-control border-0 resize-none"
                    placeholder="Escreve alguma coisa...."
                  ></textarea>
                  {file ? (
                    <img
                      src={imgselected}
                      alt=""
                      height="200px"
                      width="300px"
                    />
                  ) : (
                    ""
                  )}
                  <div className="p-2 bg-light d-flex justify-content-between align-items-center">
                    <div>
                      <label htmlFor="file">
                        <a className="btn btn-sm px-2 font-16 btn-light">
                          <i className="uil uil-scenery"></i>
                        </a>
                        <input
                          type="file"
                          id="file"
                          accept=".png,.jpeg,jpg"
                          onChange={(e) => setFile(e.target.files[0])}
                          style={{ display: "none" }}
                        />
                      </label>
                    </div>
                    <button type="submit" className="btn btn-sm btn-success">
                      <i className="uil uil-message me-1"></i>Publicar
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
